/**
 * Application Model
 */
class Model {

	constructor(verbose) {

		this.storage = null;

		/*
		 * Listeners
		 */

		$(document).on(Model.CHECK_STORAGE_AVAILABLE, $.proxy(function(_event) {
			console.info("Checking storage available...")
			try {
				// see: https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
				// try and get the local storage object
				const storage = window["localStorage"];
				// test the store
				const x = "__storage_test__";
				storage.setItem(x, x);
				storage.removeItem(x);
				// all is okay
				console.info("Local storage available.");
				this.storage = storage;
				$(document).trigger(Model.LOCAL_STORAGE_AVAILABLE);
			}
			catch (e) {
				// local storage is not available
				console.error("Local storage not available: %o", e);
			}
		}, this));

		$(document).on(Model.LOCAL_STORAGE_ADD_PRODUCT_HANDLE, $.proxy(function(_event, handle, callback) {
			console.info("Adding product handle to wishlist...");
			try {
				// check to see if the wishlist array has been initialised	
				var value = this.storage.getItem("wishlist");
				if (value == null) { value = JSON.stringify(new Array()); }
				// get the wishlist array and ads the handle to it
				const wishlist = JSON.parse(value);
				if (wishlist.includes(handle) == false) { wishlist.push(handle); }
				this.storage.setItem("wishlist", JSON.stringify(wishlist));
				// log the result and if required handle the callback
				console.log("Product handle added to wishlist.");
				if (callback != null) { callback(); }
			}
			catch (e) {
				console.error("Could not add product handle to wishlist: %o", e);
			}
		}, this));

		$(document).on(Model.LOCAL_STORAGE_RETRIEVE_PRODUCT_HANDLES, $.proxy(function(_event) {
			console.info("Retrieving wishlist product handles...");
			try {
				// check to see if the wishlist array has been initialised	
				var value = this.storage.getItem("wishlist");
				if (value == null) { value = JSON.stringify(new Array()); }
				// get and send a notification that the product handles have been retrieved
				$(document).trigger(Model.LOCAL_STORAGE_PRODUCT_HANDLES_RETRIEVED, [JSON.parse(value)]);
				console.log("Wishlist product handles retrieved.")
			}
			catch (e) {
				console.error("Could not retrieve wishlist product handles: %o", e);
			}
		}, this));

		$(document).on(Model.LOCAL_STORAGE_REMOVE_PRODUCT_HANDLE, $.proxy(function(_event, handle, callback) {
			console.info("Removing product handle from wishlist...");
			try {
				// check to see if the wishlist array has been initialised	
				var value = this.storage.getItem("wishlist");
				if (value == null) { value = JSON.stringify(new Array()); }
				// get the wishlist array and remove the handle from it
				const wishlist = JSON.parse(value);
				const index = wishlist.indexOf(handle);
				if (index > -1) { wishlist.splice(index, 1); }
				this.storage.setItem("wishlist", JSON.stringify(wishlist));
				// log the result and if required handle the callback
				console.log("Product handle removed from wishlist.");
				if (callback != null) { callback(); }
			}
			catch (e) {
				console.error("Could not remove product handle from wishlist: %o", e);
			}
		}, this));

		$(document).on(Model.LOCAL_STORAGE_REMOVE_ALL_PRODUCT_HANDLES, $.proxy(function(_event, callback) {
			console.info("Removing all product handles from wishlist...");
			try {
				// check to see if the wishlist array has been initialised	
				var value = this.storage.getItem("wishlist");
				if (value != null) { 
					// remove all the handles from the wishlist 
					this.storage.setItem("wishlist", JSON.stringify(new Array()));
				}
				// log the result and if required handle the callback
				console.log("All product handles removed from wishlist.");
				if (callback != null) { callback(); }
			}
			catch (e) {
				console.error("Could not remove all product handles from wishlist: %o", e);
			}
		}, this));
		
		$(document).on(Model.RETRIEVE_CART, function(_event) {
			console.info("Retrieving cart...");
			$.ajax({
				url: "/cart.js",
				type: "GET",
				dataType: "json",
				error: function(_xhr, status, thrown) {
					console.warn("Could not retrieve cart - status: " + status + ".", thrown);
				}
			})
			.done(function(data) {
				console.info("Cart retrieved.");
				$(document).trigger(Model.CART_RETRIEVED, [data]);
			});
		});

		$(document).on(Model.UPDATE_CART, function(_event, formData, callback) {
			console.info("Updating cart...");
			var fetchData = new Object();
			fetchData.method = "POST";
			fetchData.body = formData;
			$.ajax({
				url: "/cart/add.js",
				type: "POST",
				data: formData,
				processData: false,
				contentType: false,
				dataType: "json",
				error: function(xhr, status, thrown) {
					console.warn("Could not update cart - status: " + status + ".", thrown);
					if (xhr.status == 422) {
						alert(xhr.responseJSON.description);
						callback();							// respond to the callback so the originator's view can be updated
					}
				}
			})
			.done(function(_data) {
				console.info("Cart updated.");
				$(document).trigger(Model.RETRIEVE_CART);	// rather than attempting to update the existing cart entries, just call for the cart again
				callback();									// respond to the callback so the originator's view can be updated
			});
		});

		$(document).on(Model.UPDATE_CART_ITEM_QUANTITY, function(_event, delta) {
			console.info("Updating cart item quantity...");
			$.ajax({
				url: "/cart/change.js",
				type: "POST",
				data: delta,
				dataType: "json",
				error: function(_xhr, status, thrown) {
					console.warn("Could not update cart item quantity - status: " + status + ".", thrown);
				}
			})
			.done(function(data) {
				console.info("Cart item quantity updated.");
				$(document).trigger(Model.CART_ITEM_QUANTITY_UPDATED, [data, delta]);
			});
		});

		$(document).on(Model.DELETE_CART, function(_event) {
			console.info("Deleting cart items...");
			$.ajax({
				url: "/cart/clear.js",
				type: "POST",
				data: new Object(),
				dataType: "json",
				error: function(_xhr, status, thrown) {
					console.warn("Could not delete cart items - status: " + status + ".", thrown);
				}
			})
			.done(function(data) {
				console.info("Cart items deleted.");
				$(document).trigger(Model.CART_DELETED, [data]);
			});
		});
		
		$(document).on(Model.RETRIEVE_SEARCH_QUERY, function(_event, route, query, type, limit, callback, errorCallback) {
			if (verbose == true) { console.info("Retrieving product search..."); }
			$.ajax({
				url: route + "/suggest.json?q=" + encodeURIComponent(query) 
						   + "&resources[type]=" + encodeURIComponent(type)
						   + "&resources[limit]=" + limit,
				type: "GET",
				dataType: "json",
				error: function(_xhr, status, thrown) {
					console.warn("Could not retrieve product search - status: " + status + ".", thrown);
					if (errorCallback != null) { errorCallback(); }
				}
			})
			.done(function(data) {
				if (verbose == true) { console.info("Product search retrieved."); }
				$(document).trigger(Model.SEARCH_QUERY_RETRIEVED, [data]);
				if (callback != null) { callback(data, query); }
			});
		});

		$(document).on(Model.RETRIEVE_RELATED_PRODUCTS, function(_event, url, sectionId, productId, limit) {
			console.info("Retrieving related products...");
			$.ajax({
				url: url + "?section_id=" + sectionId + "&product_id=" + productId + "&limit=" + limit,
				type: "GET",
				dataType: "html",
				error: function(_xhr, status, thrown) {
					console.warn("Could not retrieve related products - status: " + status + ".", thrown);
				}
			})
			.done(function(data) {
				console.info("Related products retrieved.");
				$(document).trigger(Model.RELATED_PRODUCTS_RETRIEVED, [data, productId]);
			});
		});

		$(document).on(Model.RETRIEVE_RENDERED_SECTION, function(_event, url, callback, errorCallback) {
			if (verbose == true) { console.info("Retrieving rendered section..."); }
			$.ajax({
				url: url,
				type: "GET",
				dataType: "html",
				error: function(_xhr, status, thrown) {
					console.warn("Could not retrieve rendered section - status: " + status + ".", thrown);
					if (errorCallback != null) { errorCallback(); }
				}
			})
			.done(function(data) {
				if (verbose == true) { console.info("Rendered section retrieved."); }
				$(document).trigger(Model.RENDERED_SECTION_RETRIEVED, [data]);
				if (callback != null) { callback(data); }
			});
		});

	}

	/*
	 * Actions
	 */

	localStorageAvailable() {
		// see: https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
		try {
			// try and get the local storage object
			const storage = window["localStorage"];
			// test the store
			const x = "__storage_test__";
			storage.setItem(x, x);
			storage.removeItem(x);
			// all is okay
			console.info("Local storage available.")
			return storage;
		}
		catch (e) {
			// local storage is not available
			console.error("Local storage not available: code=%i, name=%s, storage=%o, length=%i", e.code, e.name, storage, storage.length);
			return null;
		}
	}

	/*
	 * Static Methods
	 */

	static isEmail(value) {
		var emailRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
		return emailRegex.test(value);
	}

}

Model.CHECK_STORAGE_AVAILABLE = "CHECK_STORAGE_AVAILABLE";
Model.LOCAL_STORAGE_AVAILABLE = "LOCAL_STORAGE_AVAILABLE";
Model.LOCAL_STORAGE_ADD_PRODUCT_HANDLE = "LOCAL_STORAGE_ADD_PRODUCT_HANDLE";
Model.LOCAL_STORAGE_PRODUCT_HANDLE_ADDED = "LOCAL_STORAGE_PRODUCT_HANDLE_ADDED";
Model.LOCAL_STORAGE_RETRIEVE_PRODUCT_HANDLES = "LOCAL_STORAGE_RETRIEVE_PRODUCT_HANDLES";
Model.LOCAL_STORAGE_PRODUCT_HANDLES_RETRIEVED = "LOCAL_STORAGE_PRODUCT_HANDLES_RETRIEVED";
Model.LOCAL_STORAGE_REMOVE_PRODUCT_HANDLE = "LOCAL_STORAGE_REMOVE_PRODUCT_HANDLE";
Model.LOCAL_STORAGE_PRODUCT_HANDLE_REMOVED = "LOCAL_STORAGE_PRODUCT_HANDLE_REMOVED";
Model.LOCAL_STORAGE_REMOVE_ALL_PRODUCT_HANDLES = "LOCAL_STORAGE_REMOVE_ALL_PRODUCT_HANDLES";
Model.LOCAL_STORAGE_ALL_PRODUCT_HANDLES_REMOVED = "LOCAL_STORAGE_ALL_PRODUCT_HANDLES_REMOVED";

Model.RETRIEVE_CART = "RETRIEVE_CART";
Model.CART_RETRIEVED = "CART_RETRIEVED";
Model.UPDATE_CART = "UPDATE_CART";
Model.CART_UPDATED = "CART_UPDATED";
Model.UPDATE_CART_ITEM_QUANTITY = "UPDATE_CART_ITEM_QUANTITY";
Model.CART_ITEM_QUANTITY_UPDATED = "CART_ITEM_QUANTITY_UPDATED";
Model.DELETE_CART = "DELETE_CART";
Model.CART_DELETED = "CART_DELETED";

Model.RETRIEVE_SEARCH_QUERY = "RETRIEVE_SEARCH_QUERY";
Model.SEARCH_QUERY_RETRIEVED = "SEARCH_QUERY_RETRIEVED";

Model.RETRIEVE_RELATED_PRODUCTS = "RETRIEVE_RELATED_PRODUCTS";
Model.RELATED_PRODUCTS_RETRIEVED = "RELATED_PRODUCTS_RETRIEVED";

Model.RETRIEVE_RENDERED_SECTION = "RETRIEVE_RENDERED_SECTION";
Model.RENDERED_SECTION_RETRIEVED = "RENDERED_SECTION_RETRIEVED";

Model.HEADER_LAST_HEIGHT_CHANGED = "HEADER_LAST_HEIGHT_CHANGED";

